import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Tavola } from "../../types"
import TavolaForm from "./TavolaForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesTavola, validationSchemaTavola } from "./TavolaCommon"

export default function TavolaModal({
  title,
  tavola,
  save,
  show,
  onClose,
}: {
  title: string
  tavola?: Tavola
  save: (values: Tavola) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesTavola(tavola) as Tavola}
      validationSchema={validationSchemaTavola()}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} backdrop="static" dialogClassName="modal-w60">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>
                <ModalTitle>{title}</ModalTitle>
              </ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <TavolaForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
